import sessionStore from '@/stores/session';
import { TRACKING_TYPE, TRACKING_OPERATION, TRACKING_PAGE } from '@/utils/constants';
import { chatbotTrackObj } from '..';

// 监听上报的意图,暂不考虑 premium user
export function toLiveAgentTrack(queue?: string) {
  return chatbotTrackObj.report({
    page_type: TRACKING_PAGE.MAIN_PAGE,
    operation: TRACKING_OPERATION.TO_LIVE_AGENT,
    // @ts-ignore
    target_type: TRACKING_TYPE.toLiveAgent,
    data: {
      queue,
      function: sessionStore.curFunction,
    },
  });
}
